"use client";

import { useRouter, useSearchParams } from "next/navigation";

interface ReviewsLinkProps {
  handle: string;
  reviewCount: number;
  className?: string;
}

export default function ReviewsLink({
  handle,
  reviewCount,
  className = "",
}: ReviewsLinkProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    const params = new URLSearchParams(searchParams);
    params.set("reviews", "true");
    
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    router.push(newUrl, { scroll: false });
  };

  return (
    <button onClick={handleClick} className={`underline ${className}`}>
      {reviewCount} Review{reviewCount !== 1 ? "s" : ""}
    </button>
  );
}
